/** @param {number} year @param {number} monthIndex 0–11 */
export function getThirdSaturdayOfMonth(year, monthIndex) {
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  let saturdays = 0;
  for (let day = 1; day <= lastDay; day++) {
    const d = new Date(year, monthIndex, day);
    if (d.getDay() === 6) {
      saturdays += 1;
      if (saturdays === 3) return day;
    }
  }
  return null;
}

/** First Saturday of Jan, Apr, Jul, Oct for the given year */
export function getQuarterlyRevivalDay(year, monthIndex) {
  const quarterStarts = [0, 3, 6, 9];
  if (!quarterStarts.includes(monthIndex)) return null;
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  for (let day = 1; day <= lastDay; day++) {
    const d = new Date(year, monthIndex, day);
    if (d.getDay() === 6) return day;
  }
  return null;
}

export function sameDate(a, y, m0, day) {
  return a.getFullYear() === y && a.getMonth() === m0 && a.getDate() === day;
}
